import React, { useMemo } from "react";
import "./navigation.scss";

/* COMPONENTS */
import { version } from "../../../package.json";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { showModal, editUser } from "../../redux/actions";
import Button from "../button/button";
import axios from "axios";
import { toast } from "react-toastify";

const Navigation = ({ history }) => {
  const room = useSelector((state) => state.room);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const truncate = (str, n) => {
    return str.length > n ? str.substring(0, n - 1) + "…" : str;
  };

  const uploadFile = async (file) => {
    const fd = new FormData();
    fd.append("profile", file);

    // SET AUTH HEADER
    axios.defaults.headers.common["x-auth-token"] = sessionStorage.getItem(
      "kzvb-obleute"
    );

    await axios
      .post(`/api/v1/users/profile`, fd)
      .then((res) => dispatch(editUser(res.data)))
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <nav className='nav'>
      <div className='nav__content'>
        {user.loaded && (
          <div className='nav__content__profile'>
            {user.data && user.data.picture.url ? (
              <div className='nav__content__profile__image'>
                <label htmlFor='profile'></label>
                <input
                  type='file'
                  name='profile'
                  id='profile'
                  accept='image/*'
                  onChange={(e) => uploadFile(e.target.files[0])}
                />
                <img
                  src={`${
                    process.env.NODE_ENV === "production"
                      ? window.location.origin
                      : "http://localhost:8000"
                  }/${user.data.picture.url}`}
                  alt=''
                />
              </div>
            ) : (
              <div className='nav__content__profile__icon'>
                <label htmlFor='profile'></label>
                <input
                  type='file'
                  name='profile'
                  id='profile'
                  onChange={(e) => uploadFile(e.target.files[0])}
                />
                {user.data && (
                  <span>
                    {user.data.firstname.charAt(0)}
                    {user.data.lastname.charAt(0)}
                  </span>
                )}
              </div>
            )}
            <div className='nav__content__profile__title'>
              <span className='nav__content__profile__title--name'>
                {user.data &&
                  `${user.data.title ? `${user.data.title} ` : ""}${
                    user.data.firstname
                  } ${user.data.lastname}`}
              </span>
              <span className='nav__content__profile__title--tag'>
                @{user.data && user.data.tag}
              </span>
            </div>
          </div>
        )}
        <div className='nav__content__pages--user'>
          <span className='nav__content__pages__header'>Themen</span>
          {room.loaded &&
            room.data &&
            room.data
              .sort((a, b) => a.order - b.order)
              .map((room) => (
                <Button
                  key={room._id}
                  className={`button-nav ${room.type ? room.type : ""}`}
                  text={truncate(room.title, 20)}
                  icon='bubbles'
                  onClick={() => history.push(`/topic/${room._id}`)}
                />
              ))}
          {user.data.admin && (
            <Button
              key={room._id}
              className={`button-nav ${room.type ? room.type : ""}`}
              text='Neues Thema'
              icon='pencil'
              onClick={() =>
                dispatch(showModal("Neues Thema erstellen", "topic"))
              }
            />
          )}
        </div>
      </div>
      <footer className='nav__footer'>
        {process.env.NODE_ENV} - {version}
      </footer>
    </nav>
  );
};

export default withRouter(Navigation);
